import { EmptyStatePlaceholder } from '@dreryk/react-components';

import { patientTranslationKeys } from '../../translations';

type PatientTablePlaceholderProps = {
   readonly searchText: string | null;
};

export const PatientTablePlaceholder = (props: PatientTablePlaceholderProps): JSX.Element => {
   if (props.searchText) {
      return (
         <EmptyStatePlaceholder heading={patientTranslationKeys.table.noSearchResults} testId={'noSearchResults'} />
      );
   }

   return <EmptyStatePlaceholder heading={patientTranslationKeys.table.noPatientsAdded} testId={'noPatientsAdded'} />;
};
